/**
 * @file psd/writer.ts
 * @description Pure writing logic for PSD files.
 */

import { ILayer } from '@hcie/core';
import { LayerData } from '../format-interface';
import { AgPsdData } from './types';
import { REVERSE_BLEND_MAP, ensureHTMLCanvas } from './utils';

declare const agPsd: any;

/**
 * Saves a list of layers to a PSD binary Uint8Array.
 */
export async function savePsdFile(
  layerList: (ILayer | LayerData)[], 
  imageWidth: number,
  imageHeight: number,
  composite?: ImageData
): Promise<Uint8Array | null> {
  if (typeof agPsd === 'undefined') {
    console.error('PSD saving library (ag-psd) is not loaded.');
    return null;
  }

  try {
    let mainCanvas: any = null;
    if (composite) {
        mainCanvas = ensureHTMLCanvas(composite);
    }

    const psdData: AgPsdData = {
      width: imageWidth,
      height: imageHeight,
      channels: 4,
      canvas: mainCanvas,
      children: layerList.map(layer => {
          const layerCanvas = ensureHTMLCanvas(layer.canvas);
          return {
            name: layer.name,
            canvas: layerCanvas as any,
            opacity: layer.opacity,
            hidden: !(layer as any).visible,
            blendMode: REVERSE_BLEND_MAP[layer.blendMode] || 'normal',
            left: (layer as any).x || 0,
            top: (layer as any).y || 0,
          };
      }),
    };
    
    const options = {
        generateThumbnail: true,
        invalidateThumbnails: true,
    };

    const result = agPsd.writePsd(psdData, options);
    return result instanceof ArrayBuffer ? new Uint8Array(result) : result;
  } catch (err) {
    console.error('Error saving PSD:', err);
    return null;
  }
}
